import {
  useSendOtpEmailMutation,
  useVerifyEmailMutation,
  useResendEmailMutation,
} from "../../../../redux/services/email";

const useEmailAuth = ({ onStarted, onSuccess, onError }) => {
  const [sendOtpEmail, { isLoading: sending }] = useSendOtpEmailMutation();
  const [verifyEmail, { isLoading: verifying }] = useVerifyEmailMutation();
  const [resendEmail, { isLoading: resending }] = useResendEmailMutation();

  const extractMessage = (e, fallback) => e.data?.message || e.message || fallback;

  const sendOtp = async (email) => {
    try {
      const data = await sendOtpEmail({ email }).unwrap();
      onStarted(data.start_token || data.startToken || null);
    } catch (e) {
      onError(extractMessage(e, "Failed to send code"));
    }
  };

  const verify = async (startToken, otp) => {
    try {
      const data = await verifyEmail({ start_token: startToken, otp }).unwrap();
      onSuccess(data);
    } catch (e) {
      onError(extractMessage(e, "Verification failed"), e.data?.attempts);
    }
  };

  const resend = async (startToken) => {
    try {
      const data = await resendEmail({ start_token: startToken }).unwrap();
      onStarted(data.start_token || data.startToken || startToken);
    } catch (e) {
      onError(extractMessage(e, "Resend failed"));
    }
  };

  return { sendOtp, verify, resend, sending, verifying, resending };
};

export default useEmailAuth;
